// extracted by mini-css-extract-plugin
export var body = "index-module--body--rYzYS";
export var content = "index-module--content--EnwiI";
export var navigation = "index-module--navigation--soJ1U";
export var title = "index-module--title--BafH6";